"use client";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import dialogImgTr from "~/assets/images/announcement/dialog-tr.png?url";
import dialogImg from "~/assets/images/announcement/dialog.png?url";
import heroContentImg1 from "~/assets/images/announcement/hero-content-img1.png?url";
import Image from "~/common/components/CustomImage";
import { LEAD_CAPTURE_MODAL_VARIANTS, openLeadCaptureModal } from "~/common/lib/leadCaptureModal";

import styles from "./AnnouncementsSection1.module.scss";

const AnnouncementsSection1 = ({ locale }) => {
  const { t } = useTranslation();

  const triggerChatbot = () => {
    openLeadCaptureModal({
      variant: LEAD_CAPTURE_MODAL_VARIANTS.BOOK_DEMO,
      source: "announcements-section-1",
    });
  };
  return (
    <div className={clsx(styles.chatbotSection1, "card")}>
      <div className={styles.chatbotSection1Content}>
        <div className={styles.chatbotSection1ContentLeft}>
          <h1 className={clsx("pal-section-title", styles.chatbotSection1Title)}>
            {t("announcements.section1.title")}
          </h1>
          <p className={clsx("pal-section-desc", styles.chatbotSection1Desc)}>
            {t("announcements.section1.description")}
          </p>
          <button onClick={triggerChatbot}>{t("announcements.section1.bookADemo")}</button>
        </div>
        <div className={styles.chatbotSection1ContentRight}>
          <Image src={heroContentImg1} alt={t("announcements.section1.heroImageAlt")} width={485} height={586} />
        </div>
      </div>
      <div className={styles.chatbotSection1Content2}>
        <h4 className={styles.chatbotSection1Content2Title}>{t("announcements.section1.content2.title")}</h4>
        <p className={styles.chatbotSection1Content2Desc}>{t("announcements.section1.content2.description")}</p>
        <div className={styles.chatbotSection1Content2Dialog}>
          <Image
            src={locale === "tr" ? dialogImgTr : dialogImg}
            alt={t("announcements.section1.dialogImageAlt")}
            width={1312}
            height={460}
          />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementsSection1;
